import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"
import * as constants from "../constants"
import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import Moment from "moment"
import NumberFormat from "react-number-format"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"

import Collapse from "@material-ui/core/Collapse"
import Avatar from "@material-ui/core/Avatar"

import "react-modern-calendar-datepicker/lib/DatePicker.css"
import Calendar from "react-modern-calendar-datepicker"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import CloseIcon from "@material-ui/icons/Close"
import CheckIcon from "@material-ui/icons/Check"
import Select from "react-select"

import ImageUploader from "react-images-upload"
import LinearProgress from "@material-ui/core/LinearProgress"

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class ChangeCarDetail extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  agentInfofilter: [],
                  rowsPerPage: 10,
                  page: 0,
                  car_id: "",
                  car_name: "",
                  car_passenger: "",
                  car_priority: "",
                  selectedCarMode: "",
                  optionCarMode: [],
                  selectedCarCompany: "",
                  optionCarCompany: [],
                  selectedCarGroup: "",
                  optionCarGroup: [],
                  car_deactive: "1",
                  car_image: "",
                  orderBy: "car_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",
                  newCar: true,
                  picturesRequestReady: "",
                  loading: false,
                  percent: 0,

                  selectedFilterCarMode: { value: 0, label: "همه انواع اتوموبیل" },
                  optionFilterCarMode: [{ value: 0, label: "همه انواع اتوموبیل" }],
                  selectedFilterCarCompany: { value: 0, label: "همه انواع برندها" },
                  optionFilterCarCompany: [{ value: 0, label: "همه انواع برندها" }],
                  selectedFilterCarGroup: { value: 0, label: "همه انواع گروه ها " },
                  optionFilterCarGroup: [{ value: 0, label: "همه انواع گروه ها " }],
                  carFiltername: "",
            }
      }

      handleFilterCarMode = (selectedFilterCarMode) => {
            this.setState(
                  {
                        selectedFilterCarMode: selectedFilterCarMode,
                        selectedFilterCarCompany: [{ value: 0, label: "همه انواع برندها" }],
                        selectedFilterCarGroup: [{ value: 0, label: "همه انواع گروه ها " }],
                  },
                  () => {
                        this.getoptionFilterCarCompany()
                  }
            )
      }

      handleFilterCarCompany = (selectedFilterCarCompany) => {
            this.setState({ selectedFilterCarCompany: selectedFilterCarCompany }, () => {
                  this.filterFieldCompany()
            })
      }
      handleFilterCarGroup = (selectedFilterCarGroup) => {
            this.setState({ selectedFilterCarGroup: selectedFilterCarGroup }, () => {
                  this.filterFieldCompany()
            })
      }

      handleChangeCarFilterName = (event) => {
            this.setState({ carFiltername: event.target.value }, () => {
                  this.filterFieldCompany()
            })
      }

      handleCarMode = (selectedCarMode) => {
            this.setState({ selectedCarMode: selectedCarMode, selectedCarCompany: "", selectedCarGroup: "" }, () => {
                  this.getoptionCarCompany()
                  this.getoptionCarGroup()
            })
      }

      handleCarCompany = (selectedCarCompany) => {
            this.setState({ selectedCarCompany: selectedCarCompany }, () => {})
      }
      handleCarGroup = (selectedCarGroup) => {
            this.setState({ selectedCarGroup: selectedCarGroup }, () => {})
      }

      handleChangeCarDetailName = (event) => {
            this.setState({ car_name: event.target.value })
      }

      handleChangeCarDetailPassenger = (event) => {
            this.setState({ car_passenger: event })
      }

      handleChangeCarDetailDesc = (event) => {
            this.setState({ car_desc: event.target.value })
      }

      onSelectPicRequest = (picture) => {
            this.setState({
                  picturesRequestReady: picture[0],
            })
      }

      handlecar_priority = (event) => {
            this.setState({ car_priority: event })
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleChangeDeactive = (event) => {
            if (event.target.checked) {
                  this.setState({ car_deactive: "0" })
            } else {
                  this.setState({ car_deactive: "1" })
            }
      }

      handleSelectRows = (row2) => {
            this.setState(
                  {
                        car_id: row2.car_id,
                        car_name: row2.car_name,
                        car_passenger: row2.car_passenger,
                        car_desc: row2.car_desc,
                        car_priority: row2.car_priority,
                        selectedCarMode: { value: row2.car_mode_id, label: row2.carmode_name },
                        selectedCarCompany: { value: row2.car_company_id, label: row2.carcompany_name },
                        selectedCarGroup: { value: row2.car_group_id, label: row2.cargroup_name },

                        car_deactive: row2.car_deactive,
                        car_image: row2.car_image,
                        newCar: false,
                  },
                  () => {
                        this.getoptionCarCompany()
                        this.getoptionCarGroup()
                  }
            )
      }

      newCar = (event) => {
            this.setState({
                  car_id: "",
                  car_name: "",
                  car_passenger: "",
                  car_desc: "",
                  car_priority: "",
                  car_deactive: "0",
                  car_image: "",
                  newCar: true,
            })
      }
      componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  var self = this
                  var xhttp = new XMLHttpRequest()
                  xhttp.onreadystatechange = function() {
                        if (this.readyState === 4 && this.status === 200) {
                              var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.getCar()
                                    self.getoptionCarMode()
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  }
                  var fd = new FormData()
                  fd.append("command", "checkemployeelogin")

                  xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }

      getoptionCarMode = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              var Company1 = [{ value: 0, label: "همه انواع اتوموبیل" }]
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].carmode_id, label: arr.data[k].carmode_name })
                                    Company1.push({ value: arr.data[k].carmode_id, label: arr.data[k].carmode_name })
                              }
                              self.setState({ optionCarMode: Company, optionFilterCarMode: Company1, selectedFilterCarMode: Company1[0] }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_carmode")
            xhttp.open("POST", `${constants.BASE_URL}/car`)
            xhttp.send(fd)
      }

      getoptionCarCompany = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].carcompany_id, label: arr.data[k].carcompany_name })
                              }
                              self.setState({ optionCarCompany: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_carcompany")
            fd.append("carmode_id", this.state.selectedCarMode.value)
            xhttp.open("POST", `${constants.BASE_URL}/car`)
            xhttp.send(fd)
      }

      getoptionFilterCarCompany = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        if (arr.result === "ok") {
                              var Company1 = [{ value: 0, label: "همه انواع برند ها" }]
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company1.push({ value: arr.data[k].carcompany_id, label: arr.data[k].carcompany_name })
                              }
                              self.setState({ optionFilterCarCompany: Company1, selectedFilterCarCompany: Company1[0] }, () => {
                                    self.getoptionFilterCarGroup()
                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_carcompany")
            fd.append("carmode_id", this.state.selectedFilterCarMode.value)
            xhttp.open("POST", `${constants.BASE_URL}/car`)
            xhttp.send(fd)
      }

      getoptionCarGroup = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              var Company = []
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company.push({ value: arr.data[k].cargroup_id, label: arr.data[k].cargroup_name })
                              }
                              self.setState({ optionCarGroup: Company }, () => {})
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_cargroup")
            fd.append("carmode_id", this.state.selectedCarMode.value)
            console.log(this.state.selectedCarMode.value)
            xhttp.open("POST", `${constants.BASE_URL}/car`)
            xhttp.send(fd)
      }

      getoptionFilterCarGroup = () => {
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              var Company1 = [{ value: 0, label: "همه انواع گروه ها " }]
                              for (var k = 0; k < arr.data.length; k++) {
                                    Company1.push({ value: arr.data[k].cargroup_id, label: arr.data[k].cargroup_name })
                              }
                              self.setState({ optionFilterCarGroup: Company1, selectedFilterCarGroup: Company1[0] }, () => {
                                    self.filterFieldCompany()
                              })
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_cargroup")
            fd.append("carmode_id", this.state.selectedFilterCarMode.value)
            xhttp.open("POST", `${constants.BASE_URL}/car`)
            xhttp.send(fd)
      }

      getCar() {
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        console.log(this.responseText)
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ requestinfos: arr.data, agentInfofilter: arr.data }, () => {
                                    self.filterFieldCompany()
                              })
                        } else if (arr.result === "error") {
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "get_car")

            xhttp.open("POST", `${constants.BASE_URL}/car`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      saveNewCar = (imageCode) => {
            const {
                  car_id,
                  car_name,
                  car_passenger,
                  car_desc,
                  selectedCarMode,
                  selectedCarCompany,
                  selectedCarGroup,
                  car_priority,
                  car_deactive,
            } = this.state
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        console.log(this.responseText)
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getCar()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "add_car")
            fd.append("car_name", car_name)
            fd.append("car_passenger", car_passenger)
            fd.append("car_desc", car_desc)
            fd.append("car_priority", car_priority)
            fd.append("car_image", imageCode)
            fd.append("car_mode_id", selectedCarMode.value)
            fd.append("car_company_id", selectedCarCompany.value)
            fd.append("car_group_id", selectedCarGroup.value)
            fd.append("car_deactive", car_deactive)

            xhttp.open("POST", `${constants.BASE_URL}/car`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }
      deleteCar = () => {
            const { car_id } = this.state
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        console.log(this.responseText)
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.newCar()
                              self.getCar()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            var fd = new FormData()
            fd.append("command", "delete_car")
            fd.append("car_id", car_id)
            xhttp.open("POST", `${constants.BASE_URL}/car`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      changeCar = (imageCode) => {
            const {
                  car_id,
                  car_name,
                  car_passenger,
                  car_desc,
                  selectedCarMode,
                  selectedCarCompany,
                  selectedCarGroup,
                  car_priority,
                  car_deactive,
            } = this.state
            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })

            var self = this
            var xhttp = new XMLHttpRequest()
            xhttp.onreadystatechange = function() {
                  if (this.readyState === 4 && this.status === 200) {
                        console.log(this.responseText)
                        var arr = JSON.parse(this.responseText)
                        console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "success" })
                              //self.setState({ redirect: true })
                              self.getCar()
                        } else if (arr.result === "error") {
                              self.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            }
            console.log(car_deactive)
            var fd = new FormData()
            fd.append("command", "modify_car")
            fd.append("car_id", car_id)
            fd.append("car_name", car_name)
            fd.append("car_passenger", car_passenger)
            fd.append("car_desc", car_desc)
            fd.append("car_priority", car_priority)
            fd.append("car_mode_id", selectedCarMode.value)
            fd.append("car_company_id", selectedCarCompany.value)
            fd.append("car_group_id", selectedCarGroup.value)
            fd.append("car_deactive", car_deactive)
            if (imageCode !== "") {
                  fd.append("car_image", imageCode)
            }

            xhttp.open("POST", `${constants.BASE_URL}/car`)
            xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            xhttp.send(fd)
      }

      uploadPicDelivery = (mode) => {
            const {
                  car_name,
                  car_passenger,
                  car_desc,
                  car_priority,
                  car_deactive,
                  selectedCarMode,
                  selectedCarCompany,
                  selectedCarGroup,
            } = this.state
            const { picturesRequestReady } = this.state
            if (car_priority != "" && car_name != "") {
                  if (picturesRequestReady && picturesRequestReady !== "" && picturesRequestReady !== null) {
                        this.setState({
                              loading: true,
                              percent: 0,
                        })

                        var self = this
                        var xhttp = new XMLHttpRequest()
                        xhttp.onreadystatechange = function() {
                              if (this.readyState === 4 && this.status === 200) {
                                    var arr = JSON.parse(this.responseText)
                                    console.log(arr)
                                    if (arr.result === "ok") {
                                          self.setState({
                                                loading: false,
                                                percent: 0,
                                          })
                                          if (mode === "new") {
                                                self.saveNewCar(arr.data["image_code"])
                                          } else {
                                                self.changeCar(arr.data["image_code"])
                                          }
                                    } else if (arr.result === "error") {
                                    }
                              }
                        }
                        var fd = new FormData()
                        fd.append("command", "uploadpic")
                        fd.append("image", picturesRequestReady)
                        fd.append("image_name", " تصویر  خودرو " + car_name)
                        fd.append("image_desc", "تصویر  خودرو " + car_name)
                        fd.append("name", "")
                        xhttp.upload.addEventListener(
                              "progress",
                              function(evt) {
                                    if (evt.lengthComputable) {
                                          var percentComplete = evt.loaded / evt.total
                                          self.setState({
                                                percent: percentComplete * 100,
                                          })
                                    }
                              },
                              false
                        )
                        xhttp.open("POST", `${constants.BASE_URL}/image`)
                        xhttp.send(fd)
                  } else {
                        console.log(mode)
                        if (mode === "new") {
                              this.saveNewCar("")
                        } else {
                              this.changeCar("")
                        }
                  }
            } else {
                  this.setState({ snackstr: "لطفا مشخصات  خودرو را وارد نمایید", showSnack: true, snackMode: "error" })
            }
      }

      createSortHandler = (field, varmod = "str") => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                  i,
                  j,
                  temp,
                  a,
                  b
            arraytemp = this.state.agentInfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (varmod == "int") {
                              if (parseInt(a[field]) < parseInt(b[field]) && this.state.order === "asc") {
                                    temp = arraytemp[j]
                                    arraytemp[j] = arraytemp[j + 1]
                                    arraytemp[j + 1] = temp
                              } else if (parseInt(a[field]) > parseInt(b[field]) && this.state.order === "desc") {
                                    temp = arraytemp[j]
                                    arraytemp[j] = arraytemp[j + 1]
                                    arraytemp[j + 1] = temp
                              }
                        } else {
                              if (a[field] < b[field] && this.state.order === "asc") {
                                    temp = arraytemp[j]
                                    arraytemp[j] = arraytemp[j + 1]
                                    arraytemp[j + 1] = temp
                              } else if (a[field] > b[field] && this.state.order === "desc") {
                                    temp = arraytemp[j]
                                    arraytemp[j] = arraytemp[j + 1]
                                    arraytemp[j + 1] = temp
                              }
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 })
      }

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) })
      }

      filterFieldCompany = () => {
            const { carFiltername, selectedFilterCarMode, selectedFilterCarCompany, selectedFilterCarGroup, requestinfos } = this.state

            var temparray = requestinfos,
                  temparray2 = [],
                  i
            for (i = 0; i < temparray.length; i++) {
                  if (
                        (selectedFilterCarMode.value === 0 || temparray[i].car_mode_id === selectedFilterCarMode.value) &&
                        (selectedFilterCarCompany.value === 0 || temparray[i].car_company_id === selectedFilterCarCompany.value) &&
                        (selectedFilterCarGroup.value === 0 || temparray[i].car_group_id === selectedFilterCarGroup.value) &&
                        (carFiltername === "" || temparray[i].car_name.indexOf(carFiltername) !== -1)
                  ) {
                        temparray2.push(temparray[i])
                  }
            }
            this.setState({ agentInfofilter: temparray2 }, () => {})
      }

      render() {
            const { classes } = this.props
            const {
                  carFiltername,
                  selectedFilterCarMode,
                  optionFilterCarMode,
                  selectedFilterCarCompany,
                  optionFilterCarCompany,
                  selectedFilterCarGroup,
                  optionFilterCarGroup,
                  optionCarMode,
                  selectedCarMode,
                  optionCarCompany,
                  selectedCarCompany,
                  optionCarGroup,
                  selectedCarGroup,
                  car_priority,
                  loading,
                  percent,
                  agentPermision,
                  snackMode,
                  snackstr,
                  showSnack,
                  newCar,
                  car_id,
                  car_name,
                  car_passenger,
                  car_desc,
                  car_image,
                  car_deactive,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  agentInfofilter,
                  rowsPerPage,
                  page,
            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                        <div className={classes.paperrtl} dir="ltr">
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>
                              <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper elevation={4} className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={6}>
                                                                  <Typography align="center" variant="h7">
                                                                        {"آی دی  خودرو:" + car_id}
                                                                  </Typography>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">نوع اتوموبیل </label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"نوع اتوموبیل"}
                                                                              value={selectedCarMode}
                                                                              onChange={this.handleCarMode}
                                                                              options={optionCarMode}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">برند اتوموبیل </label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"برند اتوموبیل"}
                                                                              value={selectedCarCompany}
                                                                              onChange={this.handleCarCompany}
                                                                              options={optionCarCompany}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">گروه اتوموبیل</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"گروه اتوموبیل"}
                                                                              value={selectedCarGroup}
                                                                              onChange={this.handleCarGroup}
                                                                              options={optionCarGroup}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        placeholder="نام خودرو"
                                                                        handleInputt={this.handleChangeCarDetailName}
                                                                        value={car_name}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        type="number"
                                                                        placeholder="تعداد سرنشین "
                                                                        handleInputt={this.handleChangeCarDetailPassenger}
                                                                        value={car_passenger}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        type="number"
                                                                        placeholder="اولویت نمایش"
                                                                        handleInputt={this.handlecar_priority}
                                                                        value={car_priority}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  <FloatingLabelInput
                                                                        placeholder="توضیحات "
                                                                        handleInputt={this.handleChangeCarDetailDesc}
                                                                        value={car_desc}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <img alt="" className={classes.large} src={car_image} />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <FormControlLabel
                                                                              control={
                                                                                    <Switch
                                                                                          checked={car_deactive === "0" ? true : false}
                                                                                          onChange={this.handleChangeDeactive}
                                                                                          name="gilad"
                                                                                    />
                                                                              }
                                                                              label="وضعیت  خودرو"
                                                                        />
                                                                  </div>
                                                            </Grid>
                                                            <Grid item xs={6}>
                                                                  <ImageUploader
                                                                        withIcon={true}
                                                                        buttonText="عکس را انتخاب نمایید"
                                                                        onChange={this.onSelectPicRequest}
                                                                        withPreview="true"
                                                                        singleImage="true"
                                                                        imgExtension={[".jpg", ".jpeg", ".gif", ".png", ".gif", ".svg", ".tiff", ".webp", ".Lottie"]}
                                                                        maxFileSize={5242880}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                  {loading && <LinearProgress variant="determinate" value={percent} />}
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  {newCar ? (
                                                                        <Button
                                                                              variant="outlined"
                                                                              color="primary"
                                                                              onClick={(e) => {
                                                                                    this.uploadPicDelivery("new")
                                                                              }}
                                                                        >
                                                                              {"ثبت  خودرو جدید "}
                                                                        </Button>
                                                                  ) : (
                                                                        <div style={{ width: "100%", textAlign: "right" }}>
                                                                              <Button variant="outlined" color="primary" onClick={this.newCar}>
                                                                                    {" خودرو جدید"}
                                                                              </Button>
                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={(e) => {
                                                                                          this.uploadPicDelivery("modify")
                                                                                    }}
                                                                              >
                                                                                    {"ثبت تغییرات"}
                                                                              </Button>

                                                                              {"          "}
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={(e) => {
                                                                                          this.deleteCar()
                                                                                    }}
                                                                              >
                                                                                    {"خذف"}
                                                                              </Button>
                                                                        </div>
                                                                  )}
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  <Divider />
                                                            </Grid>
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">نوع خودرو</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"نوع خودرو"}
                                                                              value={selectedFilterCarMode}
                                                                              onChange={this.handleFilterCarMode}
                                                                              options={optionFilterCarMode}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">برند خودرو</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"برند خودرو"}
                                                                              value={selectedFilterCarCompany}
                                                                              onChange={this.handleFilterCarCompany}
                                                                              options={optionFilterCarCompany}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <div>
                                                                        <label className="on">گروه خودرو </label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"گروه خودرو"}
                                                                              value={selectedFilterCarGroup}
                                                                              onChange={this.handleFilterCarGroup}
                                                                              options={optionFilterCarGroup}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={6}>
                                                                  <FloatingLabelInput
                                                                        placeholder="نام خودرو"
                                                                        handleInputt={this.handleChangeCarFilterName}
                                                                        value={carFiltername}
                                                                  />
                                                            </Grid>
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <TableContainer dir="rtl">
                                                            <Table aria-label="sticky table">
                                                                  <TableHead>
                                                                        <TableRow>
                                                                              <TableCell></TableCell>

                                                                              <TableCell
                                                                                    key={"car_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                                    sortDirection={orderBy === "car_id" ? order : false}
                                                                              >
                                                                                    {"آیدی"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "car_id"}
                                                                                          direction={orderBy === "car_id" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("car_id", "int")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"carcompany_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"برند خودرو"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "carcompany_name"}
                                                                                          direction={orderBy === "carcompany_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("carcompany_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell key={"car_name"} align={"center"} style={{ minWidth: 60 }}>
                                                                                    {"نام  خودرو "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "car_name"}
                                                                                          direction={orderBy === "car_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("car_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"car_passenger"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 40 }}
                                                                              >
                                                                                    {"تعداد سرنشین"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "car_passenger"}
                                                                                          direction={orderBy === "car_passenger" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("car_passenger", "int")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"carmode_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"نوع خودرو"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "carmode_name"}
                                                                                          direction={orderBy === "carmode_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("carmode_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"cargroup_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"گروه خودرو"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "cargroup_name"}
                                                                                          direction={orderBy === "cargroup_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("cargroup_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"car_priority"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 40 }}
                                                                              >
                                                                                    {" اولویت نمایش "}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "car_priority"}
                                                                                          direction={orderBy === "car_priority" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("car_priority", "int")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"car_deactive"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                              >
                                                                                    {"وضعیت  خودرو"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "car_deactive"}
                                                                                          direction={orderBy === "car_deactive" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("car_deactive")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                        </TableRow>
                                                                  </TableHead>

                                                                  <TableBody>
                                                                        {agentInfofilter
                                                                              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                                              .map((row) => {
                                                                                    return (
                                                                                          <TableRow
                                                                                                hover
                                                                                                role="checkbox"
                                                                                                tabIndex={-1}
                                                                                                key={row["car_id"]}
                                                                                                value={row}
                                                                                                onClick={() => {
                                                                                                      this.handleSelectRows(row)
                                                                                                }}
                                                                                          >
                                                                                                <TableCell>
                                                                                                      <img
                                                                                                            className={classes.small}
                                                                                                            alt=""
                                                                                                            src={row["car_image"]}
                                                                                                      />
                                                                                                </TableCell>
                                                                                                <TableCell key={"car_id"} align={"center"}>
                                                                                                      {row["car_id"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"carcompany_name"} align={"center"}>
                                                                                                      {row["carcompany_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"car_name"} align={"center"}>
                                                                                                      {row["car_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"car_passenger"} align={"center"}>
                                                                                                      {row["car_passenger"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"carmode_name"} align={"center"}>
                                                                                                      {row["carmode_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"cargroup_name"} align={"center"}>
                                                                                                      {row["cargroup_name"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"car_priority"} align={"center"}>
                                                                                                      {row["car_priority"]}
                                                                                                </TableCell>

                                                                                                <TableCell key={"car_deactive"} align={"center"}>
                                                                                                      {row["car_deactive"] === "1" ||
                                                                                                      row["car_deactive"] === 1 ? (
                                                                                                            <Fab variant="extended">
                                                                                                                  <VoiceOverOffIcon />
                                                                                                                  {"غیر فعال"}
                                                                                                            </Fab>
                                                                                                      ) : (
                                                                                                            <Fab
                                                                                                                  variant="extended"
                                                                                                                  style={{ background: "#44b700" }}
                                                                                                            >
                                                                                                                  <RecordVoiceOverIcon />
                                                                                                                  {"فعال"}
                                                                                                            </Fab>
                                                                                                      )}
                                                                                                </TableCell>
                                                                                          </TableRow>
                                                                                    )
                                                                              })}
                                                                  </TableBody>
                                                            </Table>
                                                      </TableContainer>
                                                      <TablePagination
                                                            rowsPerPageOptions={[10, 25, 100]}
                                                            component="div"
                                                            count={agentInfofilter.length}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onChangePage={this.handleChangePage}
                                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                      />
                                                </Paper>
                                          </Container>
                                    </Grid>
                              </Grid>

                              {okstatus ? (
                                    <Alert severity="success">
                                          <AlertTitle>پیام</AlertTitle>
                                          {errstr}
                                    </Alert>
                              ) : null}
                        </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangeCarDetail)
